<template>
  <div>
    <b-overlay
      :show="loading"
      z-index="9999999"
      spinner-variant="success"
      spinner-type="grow"
      no-wrap
    ></b-overlay>
    <b-card title="Card Title" no-body>
      <b-tabs card>
        <b-tab no-body @click="onTabSelected('TAGS')">
          <template v-slot:title>
            <b-icon-code-slash></b-icon-code-slash>&nbsp;Tags
          </template>
          <b-card-text>
            <Settings/>
          </b-card-text>
        </b-tab>
        <b-tab @click="onTabSelected('JAVASCRIPT_CALLBACKS')" no-body>
          <template v-slot:title>
            <b-icon-braces></b-icon-braces>&nbsp;JS Callbacks
          </template>
          <b-card-text>
            <Playground/>
          </b-card-text>
        </b-tab>
        <b-tab @click="onTabSelected('FIXED_BUTTONS')">
          <template v-slot:title>
            <b-icon-view-stacked></b-icon-view-stacked>&nbsp;Fixed Buttons
          </template>
          <b-card-text>
            <FixedButtons/>
          </b-card-text>
        </b-tab>
        <b-tab @click="onTabSelected('STARTERS')">
          <template v-slot:title>
            <b-icon-chat-square-text></b-icon-chat-square-text>&nbsp;Starters
          </template>
          <b-card-text>
            <StartersPlaceholder/>
          </b-card-text>
        </b-tab>
        <b-tab @click="onTabSelected('LOGS')">
          <template v-slot:title>
            <b-icon-newspaper></b-icon-newspaper>&nbsp;Logs
          </template>
          <b-card-text>
            <Logs/>
          </b-card-text>
        </b-tab>
        <b-tab @click="onTabSelected('GTM_DEMO')" no-body>
          <template v-slot:title>
            <b-icon-tags></b-icon-tags>&nbsp;GTM Demo
          </template>
          <b-card-text>
            <GTMDemoContainer/>
          </b-card-text>
        </b-tab>
      </b-tabs>
      <template v-slot:footer>
        <TheActionBar/>
      </template>
    </b-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TheActionBar from './TheActionBar';
import Playground from './Playground';
import Settings from './Settings';
import Logs from './Logs';
import FixedButtons from './FixedButtons';
import GTMDemoContainer from './GTMDemoContainer';
import StartersPlaceholder from './StartersPlaceholder';

const gaTabsPageMapping = {
  'TAGS': '/tags/main',
  'JAVASCRIPT_CALLBACKS': '/javascript-callbacks',
  'LOGS': '/logs',
  'GTM_DEMO': '/gtm-demo',
  'STARTERS': '/starters',
};

export default {
  components: {
    TheActionBar,
    Playground,
    Settings,
    Logs,
    FixedButtons,
    GTMDemoContainer,
    StartersPlaceholder,
  },
  data() {
    return {
      selectedTab: null,
    };
  },
  computed: {
    ...mapState([
      'settings',
      'loading',
    ])
  },
  methods: {
    onTabSelected(tab) {
      this.selectedTab = tab;
      this.$gtag.pageview(gaTabsPageMapping[tab]);
    }
  },
  mounted() {
    this.onTabSelected('TAGS');
  }
};
</script>

<style scoped>
* >>> [disabled] {
  cursor: not-allowed;
}

* >>> .bi-question-circle {
  cursor: pointer;
}
</style>
